import { Routes } from '@angular/router';
import { LayoutComponent } from './layout/layout/layout.component';
import { AuthLayoutComponent } from './layout/auth-layout/auth-layout.component';
import { authGuard } from '@core/helper/auth.guard';

export const routes: Routes = [
    {
        path: '',
        redirectTo: 'index',
        pathMatch: 'full',
    },
    {
        path: '',
        component: LayoutComponent,
        loadChildren: () =>
            import('./views/views.route').then((mod) => mod.VIEWS_ROUTES),
        canActivate: [authGuard],
    },
    {
        path: '',
        component: AuthLayoutComponent,
        loadChildren: () =>
            import('./views/error-pages/error-pages.route').then(
                (mod) => mod.ERROR_PAGES_ROUTES
            ),
    },
    {
        path: '',
        loadChildren: () =>
            import('./views/other-pages/other-page.route').then(
                (mod) => mod.OTHER_ROUTES
            ),
    },
    {
        path: '**',
        redirectTo: 'error-404',
    },
];
